import {HttpErrorResponse} from '@angular/common/http';
import {Action} from '@ngrx/store';
import {PaginationModel} from '@shared/models/pagination.model';
import {PageEdrpouClassifierModel} from '@services/back-office';
import {ErdpouClassifierSearchRequest} from '@shared/services/erdpou.service';

export enum ErdpouActionTypes {
    LoadErdpou = '[Erdpou] Load Erdpou',
    LoadErdpouSuccess = '[Erdpou] Load Erdpou Success',
    LoadErdpouFailure = '[Erdpou] Load Erdpou Failure',
    ChangePage = '[Erdpou] Change Page',
    SetInitialPagination = '[Erdpou] Set Initial Pagination',
    SetFilter = '[Erdpou] Set Filter',
    ClearFilter = '[Erdpou] Clear Filter',
    SetInitialState = '[Erdpou] Set Initial State',
}

/** Load Erdpou */
export class LoadErdpou implements Action {
    readonly type = ErdpouActionTypes.LoadErdpou;

    constructor(public payload?: { dontShowLoading: boolean }) {
    }
}

export class LoadErdpouSuccess implements Action {
    readonly type = ErdpouActionTypes.LoadErdpouSuccess;

    constructor(public payload: PageEdrpouClassifierModel) {
    }
}

export class LoadErdpouFailure implements Action {
    readonly type = ErdpouActionTypes.LoadErdpouFailure;

    constructor(public payload: HttpErrorResponse) {
    }
}

/** Change Page */
export class ChangePage implements Action {
    readonly type = ErdpouActionTypes.ChangePage;

    constructor(public payload: PaginationModel) {
    }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = ErdpouActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = ErdpouActionTypes.SetFilter;

    constructor(public payload: ErdpouClassifierSearchRequest) {
    }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = ErdpouActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = ErdpouActionTypes.SetInitialState;
}

export type ErdpouActions =
    | LoadErdpou
    | LoadErdpouSuccess
    | LoadErdpouFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    ;

